import { FC } from 'react';
import { Button, Image, Space, Typography } from 'antd';
import { useModalStateContext, useUIDispatchContext } from 'providers/UI';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';

import { getNoteText } from 'utils/getNoteText';
import { getFileUrl } from 'utils/file';
import { StyledDrawer } from './styled';

const { Text } = Typography;

const UploadPreview: FC = () => {
  const { t } = useTranslation();
  const { uploadPreview } = useModalStateContext();
  const { toggleModal } = useUIDispatchContext();

  const onClose = () => {
    toggleModal('uploadPreview', false);
  };

  return (
    <StyledDrawer
      title={`# ${uploadPreview.params?.id}`}
      footer={
        uploadPreview.params?.file ? (
          <a
            style={{ width: '100%' }}
            href={getFileUrl(uploadPreview.params?.file)}
            target="_blank"
            download={uploadPreview.params?.file}
            rel="noreferrer"
          >
            <Button style={{ width: '100%' }} size="large">
              <DownloadOutlined /> {t('reports.download')}
            </Button>
          </a>
        ) : null
      }
      onClose={onClose}
      open={uploadPreview.visible}
    >
      <Space direction="vertical" style={{ width: '100%' }} size={16}>
        {!!uploadPreview.params?.file && (
          <Space direction="vertical" style={{ width: '100%' }} size={8}>
            <Text style={{ fontWeight: 'bold' }}>{t('reports.report')}</Text>
            <div>
              <Image src="/images/format-pdf.svg" preview={false} width={24} />
              <span style={{ marginLeft: 4 }}>
                {uploadPreview.params?.file}
              </span>
            </div>
          </Space>
        )}
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          <Text style={{ fontWeight: 'bold' }}>{t('reports.note')}</Text>
          <Text>
            <span
              dangerouslySetInnerHTML={{
                __html: getNoteText(uploadPreview.params?.note || '-')
              }}
            />
          </Text>
        </Space>
      </Space>
    </StyledDrawer>
  );
};

export default UploadPreview;
